import React, { useState } from 'react';
import { MarkDownView } from './MarkDownView';
import { openCookieSettings } from '../../utils/ads';
import { sendContactMessage } from '../../server/server';

const contact = `
# O nama i kontakt

**Puškica kviz** je edukativna platforma koja kroz strukturisane oblasti, lekcije, testove znanja i interaktivne kvizove omogućava korisnicima svih uzrasta da uče, vežbaju i prate svoj napredak na jednom mestu.

Sadržaj platforme pripremaju i uređuju autori platforme. Sadržaj je edukativnog karaktera i ne garantujemo njegovu potpunu tačnost niti ishod na ispitima (vidi Uslove korišćenja). Ako primetite grešku u nekom pitanju ili lekciji, javite nam i ispravićemo je.

---

## Kontakt

- E-pošta: [puskica.kviz@gmail.com](mailto:puskica.kviz@gmail.com)
- Vlasnik: Marčetić Zoran, Milana Rakića 16, Novi Sad, Srbija

## Saradnja

Ako želite da predložite sadržaj, ispravku ili saradnju, pišite nam na istu adresu ili iskoristite formu ispod.

## Pravni dokumenti

- [Uslovi korišćenja](/user/terms)
- [Politika privatnosti](/user/privacy)
`;

const inputClass = 'w-full border border-[#999] rounded-[4px] px-3 py-2 text-[15px] text-black bg-white';

function ContactForm() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [website, setWebsite] = useState('');
    const [sending, setSending] = useState(false);
    const [result, setResult] = useState<{ ok: boolean; text: string } | null>(null);

    const submit = async (e: React.FormEvent) => {
        e.preventDefault();
        setSending(true);
        setResult(null);
        const resp = await sendContactMessage({ name: name.trim(), email: email.trim(), message: message.trim(), website });
        setSending(false);
        if (resp.status === 200) {
            setResult({ ok: true, text: 'Hvala, poruka je poslata. Odgovorićemo vam na e-poštu koju ste uneli.' });
            setName('');
            setEmail('');
            setMessage('');
        } else if (resp.status === 429) {
            setResult({ ok: false, text: 'Poslali ste previše poruka. Pokušajte ponovo kasnije ili nam pišite direktno na puskica.kviz@gmail.com.' });
        } else {
            setResult({ ok: false, text: 'Poruka nije poslata. Proverite unete podatke (poruka mora imati bar 10 karaktera) ili nam pišite na puskica.kviz@gmail.com.' });
        }
    };

    return (
        <form onSubmit={submit} className="flex flex-col gap-3 text-black">
            <h2 className="text-[20px] font-semibold">Pošaljite poruku</h2>
            <input className={inputClass} placeholder="Ime" value={name} onChange={(e) => setName(e.target.value)} required minLength={2} maxLength={100} />
            <input
                className={inputClass}
                type="email"
                placeholder="Vaša e-pošta"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                maxLength={200}
            />
            <textarea
                className={`${inputClass} min-h-[140px]`}
                placeholder="Poruka"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                minLength={10}
                maxLength={5000}
            />
            {/* honeypot: skriveno od ljudi, botovi ga popune */}
            <input
                className="hidden"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                name="website"
                value={website}
                onChange={(e) => setWebsite(e.target.value)}
            />
            <p className="text-[12px] text-gray-600">
                Slanjem poruke pristajete da vaše ime i e-poštu koristimo isključivo da bismo vam odgovorili. Više u Politici privatnosti.
            </p>
            <button type="submit" disabled={sending} className="px-4 h-[40px] w-fit rounded-[4px] text-[14px] font-semibold bg-blueDark text-white disabled:opacity-60">
                {sending ? 'Šaljem...' : 'Pošalji'}
            </button>
            {result && <p className={`text-[14px] ${result.ok ? 'text-green-700' : 'text-red-700'}`}>{result.text}</p>}
        </form>
    );
}

function ContactPage() {
    return (
        <div className="pb-[120px] w-full items-center flex flex-col bg-white min-h-full">
            <div className="flex flex-col items-center mt-[20px] w-full px-[10px]">
                <div className="w-full max-w-[834px] mt-[20px] pt-[20px] flex flex-col gap-[20px]  px-[10px]">
                    <MarkDownView style={{ color: 'black', textAlign: 'left', backgroundColor: 'transparent' }} source={contact}></MarkDownView>
                    <ContactForm />
                    <div>
                        <button onClick={openCookieSettings} className="px-4 h-[40px] rounded-[4px] text-[14px] font-semibold bg-blueDark text-white">
                            Podešavanja kolačića
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactPage;
